import React from 'react';
import { MAIN_MOCKUP_URL, PAGE_IMAGES } from '../data/assets';
type ProductStackProps = {
  label?: string;
  className?: string;
};

/**
 * Imagen de producto. Si hay mockup principal (data/assets.ts) se usa ese;
 * si no, un abanico con tres páginas reales del Volumen 2.
 */
export function ProductStack({
  label = '6 volumes · 60 meetings',
  className = ''
}: ProductStackProps) {
  if (MAIN_MOCKUP_URL) {
    return <img src={MAIN_MOCKUP_URL} alt="The six Troop Night Ready volumes and five bonuses" className={`mx-auto h-auto w-full rounded-2xl ${className}`} data-id="element-235" data-mp="dc756f95v7qy" />;
  }
  return <div className={`relative mx-auto aspect-[20/19] w-full max-w-[440px] ${className}`} data-id="element-236" data-mp="n435lwypz9yc">
      <img src={PAGE_IMAGES.meetingCard} alt="A Meeting Card page: overhead hall diagram, five-block timeline and materials" className="absolute left-[3%] top-[9%] w-[38%] -rotate-[8deg] rounded-xl shadow-stack ring-1 ring-black/10" data-id="element-237" data-mp="r3vfqe3rho5t" />
      <img src={PAGE_IMAGES.skillStation} alt="A Skill Station page teaching the square knot step by step" className="absolute right-[3%] top-[9%] w-[38%] rotate-[8deg] rounded-xl shadow-stack ring-1 ring-black/10" data-id="element-238" data-mp="1j1sonzq0pgaj" />
      <img src={PAGE_IMAGES.cover} alt="Troop Night Ready Volume 2 cover: Knots, Ropes and Pioneering" className="absolute left-1/2 top-0 z-10 w-[46%] -translate-x-1/2 rounded-xl shadow-stack ring-1 ring-black/10" data-id="element-239" data-mp="1a0uqvz66a50e" />
      <span className="absolute bottom-0 left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded-full bg-ember px-4 py-2 text-[12px] font-bold uppercase tracking-wide text-pine shadow-card" data-id="element-240" data-mp="1xpng7csahem1">
        {label}
      </span>
    </div>;
}